import logo from "./logo.svg";
import "./App.css";
import MainLayout from "./components/layout/MainLayout";
import AllRoutes from "./AllRoutes";

function App() {
  return (
    <>
      <MainLayout>
        <AllRoutes />
      </MainLayout>
    </>
  );
}

export default App;
